import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("autopost_token");
    const u = localStorage.getItem("autopost_user");
    if (t && u) {
      setUser(JSON.parse(u));
      api.get("/auth/me")
        .then((r) => {
          setUser(r.data);
          localStorage.setItem("autopost_user", JSON.stringify(r.data));
        })
        .catch(() => {
          localStorage.removeItem("autopost_token");
          localStorage.removeItem("autopost_user");
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("autopost_token", data.access_token);
    localStorage.setItem("autopost_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, ref) => {
    const payload = { name, email, password };
    if (ref) payload.ref = ref;
    const { data } = await api.post("/auth/register", payload);
    // Não loga direto — precisa confirmar o código de verificação primeiro.
    return data; // { ok, email_verification_required, email, message }
  };

  const verifyEmail = async (email, codigo) => {
    const { data } = await api.post("/auth/verify-email", { email, codigo });
    localStorage.setItem("autopost_token", data.access_token);
    localStorage.setItem("autopost_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const resendVerification = async (email) => {
    const { data } = await api.post("/auth/resend-verification", { email });
    return data;
  };

  const forgotPassword = async (email) => {
    const { data } = await api.post("/auth/forgot-password", { email });
    return data;
  };

  const resetPassword = async (email, codigo, newPassword) => {
    const { data } = await api.post("/auth/reset-password", { email, codigo, new_password: newPassword });
    localStorage.setItem("autopost_token", data.access_token);
    localStorage.setItem("autopost_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  // ── Google Login ──────────────────────────────────────────────────────────
  const googleLogin = async (credential) => {
    const { data } = await api.post("/auth/google", { credential });
    localStorage.setItem("autopost_token", data.access_token);
    localStorage.setItem("autopost_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("autopost_token");
    localStorage.removeItem("autopost_user");
    setUser(null);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    localStorage.setItem("autopost_user", JSON.stringify(data));
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, verifyEmail, resendVerification, forgotPassword, resetPassword, googleLogin, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const c = useContext(AuthContext);
  if (!c) throw new Error("useAuth must be used within AuthProvider");
  return c;
};
